import { FormControl, FormGroup, FormLabel, TextField } from '@mui/material';
import ActionButton from 'common/components/ActionButton';
import CustomTextValidator from 'common/components/CustomTextValidators';
import useFlexBoxStyles from 'common/flexBox';
import { useTranslation } from 'react-i18next';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
    return {
        textField: {
            '& .MuiInputBase-root': {
                background: '#FFFF',
                borderRadius: theme.spacing(2),
                [theme.breakpoints.up('xl')]: {
                    height: 'auto',
                    borderRadius: theme.spacing(2.5),
                },

                '& > fieldset': {
                    borderColor: '#E2E2E2',
                },

                '& > input': {
                    padding: theme.spacing(0, 1),
                    height: '100%',
                    fontSize: '12px',
                    fontWeight: '500',
                    position: 'relative',
                    '&:focus': {
                        borderRadius: 5,
                    },
                    [theme.breakpoints.up('xl')]: {
                        fontSize: '14px',
                    },
                },
            },
        },
    };
});

const ShortVideoFormSettings = (props) => {
    const { data, handleFieldChange, step, setStep, cancel } = props;

    const { t } = useTranslation();
    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();

    const validateForm = () => {
        return data.name.length < 100 && data.name.length > 0;
    };

    const submit = () => {
        console.debug('submit');
    };

    return (
        <ValidatorForm
            onSubmit={submit}
            onError={(e) => {}}
            className={cx(flexBox.flex, flexBox.gap2, flexBox.column, flexBox.overflowHidden)}
        >
            <div
                className={cx(
                    flexBox.flex,
                    flexBox.gap2,
                    flexBox.column,
                    flexBox.overflowXHidden,
                    flexBox.scrollbarNone,
                )}
            >
                <FormGroup>
                    <FormLabel>{t('contact.name')}</FormLabel>
                    <CustomTextValidator
                        name="name"
                        fullWidth={true}
                        variant="outlined"
                        size="small"
                        autoComplete="new-name"
                        value={data.name}
                        onChange={handleFieldChange}
                        validators={['required', 'maxStringLength: 100']}
                        errorMessages={[t('game.gameSurveyForm.nameRequired'), t('event.form.maxLength')]}
                    />
                </FormGroup>

                <FormGroup>
                    <FormLabel>{t('event.eventFormSettings.description')}</FormLabel>
                    <FormControl variant="outlined" size="small">
                        <TextField
                            className={classes.textField}
                            name="description"
                            value={data.description}
                            onChange={handleFieldChange}
                            variant="outlined"
                            size="small"
                            multiline
                            rows={3}
                            placeholder={t('event.eventFormSettings.descriptionPlaceholder')}
                        />
                    </FormControl>
                </FormGroup>
            </div>

            <div className={cx(flexBox.flex, flexBox.gap1, flexBox.justifyContentEnd, flexBox.paddingTop2)}>
                <ActionButton onClick={cancel} color="default" fitWidth>
                    {t('multimedia.multimediaForm.cancel')}
                </ActionButton>

                <ActionButton
                    disabled={!validateForm()}
                    color="primary"
                    autoFocus
                    fitWidth
                    onClick={() => setStep(step + 1)}
                >
                    {t('event.eventFormSettings.save')}
                </ActionButton>
            </div>
        </ValidatorForm>
    );
};

export default ShortVideoFormSettings;
